import styled from 'styled-components';

export const SearchBox = styled.div`
    width: 100%;
    background: #fff;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 20px;
    display: flex;
    // justify-content: flex-start;
    // align-items: stretch;
    column-gap: 20px;
    padding: 0;
    margin-bottom:20px;
    
    &:last-child{
      margin-bottom:0px;
    }
    
    @media screen and (max-width: 991px){
        border-radius: 15px;
    }
    
    @media screen and (max-width: 575px){
        flex-direction: column;
    }
`;

export const SearchBoxImage = styled.div`
    width: 25%;    
    position: relative; 
    max-width: 200px;
    border-radius: 20px;
    //  min-height: 294px;
     a{
       display: inline-flex;
         height: 100%;
     }
    @media screen and (max-width: 1440px){ 
        width: 30%;
    }
    @media screen and (max-width: 991px){
        width: 40%;
        border-radius: 15px;
    }
    @media screen and (max-width: 575px){
        width: 100%;
        max-width: 100%;
    }

    img{
     max-width: 200px;
    height: 100%;
    border-radius: 20px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;

        @media screen and (max-width: 991px){
            border-radius: 15px;
        }

        @media screen and (max-width: 575px){
            max-width: 100%;
            width: 100%;    
            border-radius: 15px;
        }
    }

    .search-img-ss{
       object-fit: cover;
        
    }
`; 

export const TopRatedTest = styled.div`
    background: #F7931E;
    border-radius: 17px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    max-width: 167px;
    column-gap: 10px;
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 10px;
    margin: auto;

    @media screen and (max-width: 991px){
        border-radius: 15px;
    }

    img{
        background: #FFFFFF;
        border-radius: 17px;
        padding: 7px;

        @media screen and (max-width: 991px){
            border-radius: 15px;
        }
        
        @media screen and (max-width: 575px){
            max-width: 38px;
            border-radius: 10px;
        }
    }
`;

export const TopRatedImgText = styled.p`
    color: #333333;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 18px;
    margin: 0;
    text-align: left;
`;

export const SearchBoxContent = styled.div`
    width: 76%;
    padding: 15px 20px 15px 0px;

    @media screen and (max-width: 991px){
        width: 60%;
    }
    
    @media screen and (max-width: 575px){
        width: 100%;
        padding: 20px;
    }

    a{
        text-decoration: none;
    }
`;

export const SearchBoxContentTitle = styled.h2`
    color: #33A7AE;
    font-size: 18px;
    font-weight: 600;
    font-family: 'Jost', sans-serif;
    line-height: 26px;
`;

export const ReviewBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 10px;
    margin: 10px 0;
    flex-direction: column;

    strong{
        color:#333333;
        font-size: 16px;
        font-family: 'Jost', sans-serif;
        font-weight: 500;
        line-height: 20px;
    }
`;

export const SearchRatingStar = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 12px;
`;

export const CityName = styled.div`
    color: #333333;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 20px; 
`;

export const SearchDonner = styled.div`
    background: #F3F3F3;
    border-radius: 8px; 
    padding: 10px;
`;

export const DonnerImage = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 10px;
    margin-bottom: 5px;

    img{
        width: 36px;
        height: 36px;
        border: 1px solid #33A7AE;
        border-radius: 4px;
        display: inline-block;
    }
`;

export const DonnerName = styled.div`
    font-size: 14px;
    font-weight: 400;
    font-family: 'Jost', sans-serif;
    line-height: 20px;
    color: #000000;
`;

export const DonnerSay = styled.div`
    width: 100%;
    color: rgb(0 0 0 / 80%);
    font-size: 14px;
    font-weight: 400;
    font-family: 'Jost', sans-serif;
    line-height: 22px
    p{
        overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
            line-clamp: 2; 
    -webkit-box-orient: vertical;
        margin-bottom: 0;
    }
`;

export const ReadMoreText = styled.button`
    font-weight: 700;
    color: rgb(0 0 0 / 80%);
    border: none;
        padding: 0;
`;

export const SearchBoxButtonGroup = styled.div`
    display: flex;
    align-items: center;
    column-gap: 15px;
    margin-top: 15px;


    @media screen and (max-width: 420px){
        flex-direction: column;
        row-gap: 15px;
    }
    
    button{
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        padding: 11px 41px;

        @media screen and (max-width: 1200px){
            padding: 11px 30px;
        }

        @media screen and (max-width: 1200px){
            padding: 11px 20px;
        }

        @media screen and (max-width: 480px){
            font-size: 14px;
            line-height: 22px;
            padding: 11px 10px;
            width: 100%;
        }
    }
`;